import { render, staticRenderFns } from "./ClientTracks.vue?vue&type=template&id=5ff2bc00&scoped=true&lang=pug"
import script from "./ClientTracks.vue?vue&type=script&lang=js"
export * from "./ClientTracks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2bc00",
  null
  
)

export default component.exports